<template>
  <div class="issue-inline-field issue-inline-field--offset-field typo-small-title">
    <div class="issue-inline-field__title">
      {{ $t('issues.risk_rating') }}
    </div>
    <div class="issue-inline-field__field">
      <div
        v-if="riskRatingLevel"
        :class="`issue-ratings__risk issue-ratings__risk--${ riskRatingLevel }`"
      >
        <span>{{ $t(`risk_levels.${riskRatingLevel}`) }}</span> <span class="issue-ratings__risk-number typo-rating">{{ riskRating }}</span>
      </div>
      <div v-if="!riskRatingLevel" class="issue-ratings__risk issue-ratings__risk--unknown">
        {{ $t('issues.unable_to_calculate') }}
      </div>

      <InfoPopup>
        <template #trigger>
          <IEncircledSvg class="issue-ratings__info" />
        </template>

        {{
          riskRatingLevel ?
            $t(`issues.risk_rating_description.${riskRatingLevel}`) :
            $t('issues.unable_to_calculate_description')
        }}
      </InfoPopup>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';

import InfoPopup from '@/components/generic/info_popup.vue';

import IEncircledSvg from '@/images/i_encircled.svg';

import calculateRiskRating from '@/functions/simm/calculate_risk_rating';
import getRiskRatingLevel from '@/functions/simm/get_risk_rating_level';

const props = defineProps({
  issue: { type: Object, required: true },
});

const riskRating = computed(() => {
  if (props.issue.risk_rating) {
    return props.issue.risk_rating;
  }
  if (
    !props.issue.element_class ||
    (typeof props.issue.overall_condition_rating !== 'number')
  ) {
    return null;
  }
  return calculateRiskRating(props.issue.element_class, props.issue.overall_condition_rating);
});

const riskRatingLevel = computed(() => {
  if (!riskRating.value) {
    return null;
  }
  return getRiskRatingLevel(riskRating.value);
});
</script>
